module.exports = __webpack_public_path__ + "static/media/choux-fleur.13beb991.svg";